'use client';

import clsx from 'clsx';
import { FC, useLayoutEffect, useRef } from 'react';

export type TextareaProps = {
    value: string;
    setValue: (val: string) => void;
    className?: string;
    id?: string;
    ariaLabel?: string;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    rows?: number;
    autoGrow?: boolean;
};

const Textarea: FC<TextareaProps> = ({
    setValue,
    value,
    className,
    id,
    ariaLabel,
    disabled,
    readOnly,
    rows = 3,
    placeholder = 'Введите текст',
    autoGrow = false,
}) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useLayoutEffect(() => {
        if (!autoGrow || !textareaRef.current) return;

        const textarea = textareaRef.current;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }, [autoGrow, value]);

    return (
        <textarea
            ref={textareaRef}
            id={id}
            aria-label={ariaLabel}
            onChange={(e) => {
                if (autoGrow) {
                    const textarea = e.currentTarget;
                    textarea.style.height = 'auto';
                    textarea.style.height = `${textarea.scrollHeight}px`;
                }

                setValue(e.target.value);
            }}
            value={value}
            className={clsx(
                'bg-white w-full rounded-lg outline-0 p-4 text-sm leading-5 resize-none',
                autoGrow && 'overflow-hidden',
                className,
            )}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            rows={rows}
        ></textarea>
    );
};

export default Textarea;
